import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// @material-ui/icons
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import splash from 'assets/images/mobile.png';
import appstore1 from 'assets/img/googleApp.png';
import appstore2 from 'assets/img/appleApp.png';
import productStyle from 'assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx';
import { Person, CalendarToday, CreditCard } from '@material-ui/icons';
import { FormattedMessage, injectIntl } from 'react-intl';
import { APP_NAME } from '../../utils/config/constants';

class AppLinks extends React.Component {
    render() {
        const { classes, settings } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <div className="web-app com-padd">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 web-app-img">
                                {' '}
                                <img src={splash} alt={APP_NAME} />{' '}
                            </div>
                            <div className="col-md-6 web-app-con">
                                {/* <h2 className={classes.title}>
                                    <FormattedMessage
                                        id="downloadLink"
                                        defaultMessage={`Download ${APP_NAME} App Now`}
                                    />
                                </h2> */}
                                <h2>
                                    Looking for the Best Service Provider?{' '}
                                    <span>Get the App!</span>
                                </h2>
                                {/* <p className={classes.description}>
                                    <FormattedMessage
                                        id="about.description"
                                        defaultMessage={`${APP_NAME} is an on-demand app platform that will
                                provide you advanced on-demand clone scripts
                                that are fully customized as per your business
                                requirements.`}
                                    />
                                </p> */}
                                <ul>
                                    <li>
                                        <i
                                            className="fa fa-check"
                                            aria-hidden="true"
                                        />{' '}
                                        Find nearby listings
                                    </li>
                                    <li>
                                        <i
                                            className="fa fa-check"
                                            aria-hidden="true"
                                        />{' '}
                                        Easy service enquiry
                                    </li>
                                    <li>
                                        <i
                                            className="fa fa-check"
                                            aria-hidden="true"
                                        />{' '}
                                        Listing reviews and ratings
                                    </li>
                                    <li>
                                        <i
                                            className="fa fa-check"
                                            aria-hidden="true"
                                        />{' '}
                                        Manage your listing, enquiry and reviews
                                    </li>
                                </ul>{' '}
                                <ul className="d-flex download-app-ul">
                                    {this.props.settings.constants
                                        .androidCustomerAppLink &&
                                        this.props.settings.constants
                                            .androidCustomerAppLink != '' && (
                                            <li>
                                                <a
                                                    target="_blank"
                                                    href={
                                                        this.props.settings
                                                            .constants
                                                            .androidCustomerAppLink
                                                    }
                                                >
                                                    <img
                                                        src={appstore1}
                                                        alt={APP_NAME}
                                                    />
                                                </a>
                                            </li>
                                        )}
                                    {this.props.settings.constants
                                        .iosCustomerAppLink &&
                                        this.props.settings.constants
                                            .iosCustomerAppLink != '' && (
                                            <li>
                                                <a
                                                    target="_blank"
                                                    href={
                                                        this.props.settings
                                                            .constants
                                                            .iosCustomerAppLink
                                                    }
                                                >
                                                    <img
                                                        src={appstore2}
                                                        alt={APP_NAME}
                                                    />
                                                </a>
                                            </li>
                                        )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(productStyle)(injectIntl(AppLinks));



// WEBPACK FOOTER //
// ./src/components/About/AppLinks.js